import { render, staticRenderFns } from "./manageCard.vue?vue&type=template&id=1e52c546&scoped=true"
import script from "./manageCard.vue?vue&type=script&lang=js"
export * from "./manageCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e52c546",
  null
  
)

export default component.exports